<template>
  <section>
    <p>Informe de Llamadas</p>
    <activity-overview />
  </section>
</template>

<script>
import ActivityOverview from "@/components/Agents/ActivityOverview/CallsInformation.vue";
export default {
  components: {
    ActivityOverview,
  },
};
</script>

<style></style>
